// @flow
import React from 'react';
import glamorous from 'glamorous';
import useSheet from 'app/jss';
import Avatar from 'app/components/commons/Avatar';

type Props = {
  classes: Object,
  errored?: boolean,
  friend: User | FriendRequest | Friend,
  subtitle?: string,
};

const defaultProps = {
  errored: false,
  subtitle: undefined,
};

const StyledAvatar = glamorous(Avatar)({
  fontSize: '1.4em',
});

function FriendIdentity({ classes, errored, friend, subtitle }: Props) {
  return (
    <div className={classes.identity}>
      <StyledAvatar avatar={friend.avatar} errored={errored} size="large" status={friend.status} />
      <span className={classes.username}>{friend.username}</span>
      {subtitle && <span className={classes.subTitle}>{subtitle}</span>}
    </div>
  );
}

FriendIdentity.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    identity: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    username: {
      color: theme.color.basis1,
      fontSize: 18,
      marginTop: 4,
    },
    subTitle: {
      color: theme.color.basis4,
      fontSize: 16,
      marginTop: -4,
    },
  };
}

export default useSheet(applyStyles)(FriendIdentity);
